<div class="activation-link-form">
  <ng-container *ngIf="!_loading.getPlans && !loadingExternal">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-sm-12">
          <label for="firstName" translate>sales.activation-link.form.firstName.label</label>
          <div class="vox-input-group vox-input-group_dense"
              [ngClass]="{'vox-input-group_invalid': isControlInvalid('name')}">
              <input class="vox-text-field" type="text" id="firstName"
              placeholder="{{'sales.activation-link.form.firstName.placeholder' | translate}}"
              formControlName='name' />
              <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
              <span class="vox-input-group__error-message" translate>sales.activation-link.form.error</span>
          </div>
        </div>
        <div class="col-sm-12">
          <label for="country" translate>sales.activation-link.form.country.label</label>
          <vox-select-country [language]="language$ | async" [searchEnabled]="false" [countryList]="countries"
          [dense]="true" formControlName="country">
          </vox-select-country>
        </div>
        <div class="col-sm-12">
          <div class="link-label-container">
            <label for="deal" translate>sales.activation-link.form.hubspot-deal-id.label</label>
            <button class='vox-btn link-btn' tabindex="-1" type="button" (click)="openDealIdModal()"
            translate>sales.activation-link.form.hubspot-deal-id.link</button>
          </div>
          <div class="vox-input-group vox-input-group_dense"
          [ngClass]="{'vox-input-group_invalid': isControlInvalid('deal_id')}">
            <input class="vox-text-field" type="text" id="deal"
            placeholder="{{'sales.activation-link.form.hubspot-deal-id.placeholder' | translate}}"
            formControlName='deal_id'/>
            <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span class="vox-input-group__error-message" translate>sales.activation-link.form.error</span>
          </div>
        </div>
        <div class="col-sm-12">
          <label for="expires" translate>sales.activation-link.form.expires.label</label>
          <div ngbDropdown class="vox-dropdown-input dropdown">
            <button class="dropdown__btn" id="expires" type="button" ngbDropdownToggle>
              {{getFormControl('expires').value.value}}
              {{getFormControl('expires').value.unit | translate}}
            </button>
            <div ngbDropdownMenu aria-labelledby="expires">
              <button *ngFor="let e of expiresList" ngbDropdownItem
              class="dropdown__item" type="button" (click)="selectExpires(e)">
                {{e.value}}
                {{e.unit | translate}}
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <label for="sms" translate>sales.trial-link.form.sms.label</label>
          <div class="vox-input-group">
            <label class="vox-field-label">
              <input type="radio" class="vox-radio" [value]="true"
              (click)="getFormControl('sms').setValue(true)" formControlName="sms"/>
              {{'sales.trial-link.form.sms.yes' | translate}}
            </label>
            <label class="vox-field-label">
              <input type="radio" class="vox-radio" [value]="false"
              (click)="getFormControl('sms').setValue(false)" formControlName="sms"/>
              {{'sales.trial-link.form.sms.no' | translate}}
            </label>
          </div>
        </div>
        <div *ngIf="allowWifi" class="col-sm-12">
          <label for="wifi" translate>sales.activation-link.form.wifi.label</label>
          <div ngbDropdown class="vox-dropdown-input dropdown">
            <button class="dropdown__btn" id="wifi" type="button" [disabled]="isWifiDisabled" ngbDropdownToggle >
              {{'sales.activation-link.form.wifi.' + getFormControl('wifi').value | translate}}
            </button>
            <div ngbDropdownMenu aria-labelledby="wifi">
              <button
              *ngFor="let w of wifiList"
              ngbDropdownItem
              class="dropdown__item" type="button"
              (click)="selectWifi(w)" translate> sales.activation-link.form.wifi.{{w}}
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <label for="paymentMethod" translate>sales.activation-link.form.payment-method.label</label>
          <div ngbDropdown class="vox-dropdown-input dropdown">
            <button class="dropdown__btn" id="paymentMethod" type="button" ngbDropdownToggle >
              {{'sales.activation-link.form.payment-method.items.' + getFormControl('paymentMethod').value | translate}}
            </button>
            <div ngbDropdownMenu aria-labelledby="paymentMethod">
              <button
              *ngFor="let p of paymentMethodsList"
              ngbDropdownItem
              class="dropdown__item" type="button"
              (click)="selectPaymentMethod(p)" translate> sales.activation-link.form.payment-method.items.{{p}}
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="allowDiscount" class="col-sm-12 checkbox-container"
        [ngClass]="{'checkbox-container--mb': !getFormControl('discount').value}">
          <input class="vox-checkbox" type="checkbox"
          formControlName="discount" (click)="setApplyDiscount()"/>
          <label translate>sales.activation-link.form.apply-discount.label</label>
        </div>
        <ng-container *ngIf="getFormControl('discount').value">
          <div class="col-sm-12">
            <label for="amount" translate>sales.activation-link.form.amount.label</label>
            <div ngbDropdown class="vox-dropdown-input dropdown">
              <button class="dropdown__btn" id="amount" type="button" ngbDropdownToggle>
                {{getFormControl('amount').value}}%
              </button>
              <div ngbDropdownMenu aria-labelledby="amount">
                <button
                *ngFor="let a of discountAmountList"
                ngbDropdownItem
                class="dropdown__item" type="button"
                (click)="selectAmount(a)">
                  {{a}}%
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <label for="duration" translate>sales.activation-link.form.duration.label</label>
            <div class="duration-container">
              <div class="duration-container--duration">
                <gdp-quantity-selector [min]="1" [max]="24" formControlName="duration"
                [disabled]="getFormControl('durationForever').value"
                ></gdp-quantity-selector>
              </div>
              <div class="duration-container--forever">
                <div class="d-flex">
                  <input
                  type="checkbox"
                  class="vox-checkbox mr-2"
                  formControlName="durationForever"/>
                  <label class="mb-0" translate>sales.activation-link.form.duration.forever</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <label for="plans" translate>sales.activation-link.form.plans.label</label>
            <div class="vox-input-group vox-input-group_dense"
              [ngClass]="{'vox-input-group_invalid': getFormControl('plans').invalid && getFormControl('plans').touched}">
              <vox-dropdown-multiselect
              [formControl]="getFormControl('plans')"
              [dropdownList]="dropdownList"
              [settings]="dropdownSettings"
              [placeholder]="placeholder"
              [language]="language$ | async"
              [setDense]="dense"
              [layout]="layout"
              [isDisabled]="dropdownDisabled">
              </vox-dropdown-multiselect>
              <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
              <span class="vox-input-group__error-message" translate>sales.activation-link.form.error</span>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </ng-container>
  <ng-container *ngIf="_loading.getPlans || loadingExternal">
    <form>
      <div class="row">
        <div class="col-sm-12">
          <ngx-skeleton-loader [theme]="{'width':'150px', 'height': '24px'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height':'40px'}"></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12">
          <ngx-skeleton-loader [theme]="{'width':'150px', 'height': '24px'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height':'40px'}"></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12">
          <ngx-skeleton-loader [theme]="{'width':'150px', 'height': '24px'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height':'40px'}"></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12">
          <ngx-skeleton-loader [theme]="{'width':'150px', 'height': '24px'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height':'40px'}"></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12">
          <ngx-skeleton-loader [theme]="{'width':'150px', 'height': '24px'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height':'40px'}"></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12">
          <ngx-skeleton-loader [theme]="{'width':'150px', 'height': '24px'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height':'40px'}"></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12">
          <ngx-skeleton-loader [theme]="{'width':'150px', 'height': '24px'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height':'40px'}"></ngx-skeleton-loader>
        </div>
        <div class="col-sm-12">
          <ngx-skeleton-loader [theme]="{'width':'150px', 'height': '24px'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{'height':'40px'}"></ngx-skeleton-loader>
        </div>
      </div>
    </form>
  </ng-container>
</div>
